import i18n from '@/i18n';
import { TYPE_COMMANDE } from '@/configuration/devisConf';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import translate from '@/services/devisCommandes/validation/champsCommandeTranslator';

const basei18n = 'importDonneIdelia.commande.errors';

const validation = (errors, msgError) => {
  errors.forEach(message => {
    if (message.includes('IMPORT_COMMANDE_DATE_COMMANDE_WRONG_FORMAT')) {
      msgError.push({ message: `${basei18n}.dateCommandeWrongFormat` });
    }
    if (message.includes('IMPORT_COMMANDE_NUM_COMMANDE_REQUIERED')) {
      msgError.push({ message: `${basei18n}.numCommandeRequired` });
    }
    if (message.includes('IMPORT_COMMANDE_CLIENT_REQUIERED')) {
      msgError.push({ message: `${basei18n}.clientRequiered` });
    }
    if (message.includes('IMPORT_COMMANDE_PRODUIT_REQUIERED')) {
      msgError.push({ message: `${basei18n}.produitRequiered` });
    }
    if (message.includes('IMPORT_COMMANDE_QUANTITE_IS_INVALID')) {
      msgError.push({ message: `${basei18n}.quantiteIsInvalide` });
    }
    if (message.includes('IMPORT_COMMANDE_PRIX_UNITAIRE_IS_INVALID')) {
      msgError.push({ message: `${basei18n}.prixUnitaireIsInvalide` });
    }
    if (message.includes('IMPORT_COMMANDE_TAUX_REMISE_IS_INVALID')) {
      msgError.push({ message: `${basei18n}.tauxRemiseIsInvalide` });
    }
    if (message.includes('IMPORT_COMMANDE_TOTAL_HT_IS_INVALID')) {
      msgError.push({ message: `${basei18n}.totalHtIsInvalide` });
    }
    if (message.includes('IMPORT_COMMANDE_TAUX_TVA_IS_INVALID')) {
      msgError.push({ message: `${basei18n}.tauxTvaIsInvalide` });
    }
    if (message.includes('IMPORT_COMMANDE_DATE_COMMANDE_NOT_SAME_AS_FIRST_LINE')) {
      msgError.push({ message: `${basei18n}.dateCommandeNotSameAsFirstLine` });
    }
    if (message.includes('IMPORT_COMMANDE_CLIENT_NOT_SAME_AS_FIRST_LINE')) {
      msgError.push({ message: `${basei18n}.clientNotSameAsFirstLine` });
    }
    if (message.includes('IMPORT_COMMANDE_PRODUIT_REFERENCE_NOT_EXIST_IN_DB')) {
      msgError.push({ message: `${basei18n}.produitReferenceNotExistInDb` });
    }
    if (message.includes('IMPORT_COMMANDE_CLIENT_CODE_NOT_EXIST_IN_DB')) {
      msgError.push({ message: `${basei18n}.clientCodeNotExistInDb` });
    }
    if (message.includes('IMPORT_COMMANDE_TAUX_TVA_NOT_EXIST_IN_DB')) {
      msgError.push({ message: `${basei18n}.tauxTvaNotExistInDb` });
    }
    if (message.includes('IMPORT_COMMANDE_PRODUCT_HAS_MANY_PARENT')) {
      msgError.push({ message: `${basei18n}.productHasManyParent` });
    }
    if (message.includes('IMPORT_COMMANDE_PRODUCT_REFERENCE_IS_NOT_UNIQUE')) {
      msgError.push({ message: `${basei18n}.productReferenceIsNotUnique` });
    }
  });
};

export default function validationDataImportCommande(data) {
  data.forEach(item => {
    const messages = item.messages;
    const msgError = [];
    const champsVide = [];
    const messagesChampsVide = [];
    const response = { data: { error: { validationErrors: messages.map(m => ({ message: m })) } } };
    validation(messages, msgError);
    validationDevisCommande(response, msgError, null, TYPE_COMMANDE);
    validationGeneral(i18n, response, champsVide, msgError, messagesChampsVide, translate);
    item.messages = [
      ...champsVide,
      ...messagesChampsVide,
      ...msgError.map(error => i18n.t(error.message, error.parametres)),
    ];
  });
}
